import * as React from 'react';
const ConvalescenzaIcon = ({ primaryColor, secondaryColor, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-2{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px;stroke:${primaryColor ||
        '#282828'}}`}</style>
    </defs>
    <circle cx={128.47} cy={126.25} r={5.37} className="prefix__cls-2" />
    <circle cx={81.95} cy={126.25} r={5.37} className="prefix__cls-2" />
    <path d="m59.01 81.53 18.46 16.09h63.52" className="prefix__cls-2" />
    <path
      d="M130.26 90.46H141v-1.79c0-3.95-3.2-7.16-7.16-7.16H86.18L73 70.77c-4.09-2.78-7.16-3.58-10.74 0l-1.79 1.79 21.47 17.89h33.55"
      style={{
        stroke: secondaryColor || '#ffcf38',
        fill: 'none',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: '3.89px',
      }}
    />
    <path
      d="M92.68 126.25h25.05M89.1 119.09l37.58-21.47M121.31 119.09 83.74 97.62"
      className="prefix__cls-2"
    />
  </svg>
);
export default ConvalescenzaIcon;
